
<div>
  <button
      data-toggle="collapse"
      :href="`#${id}`"
      role="button"
      :aria-expanded="isOpen.toString()"
      :aria-controls="controlName"
      :disabled="disabled"
      @click.once="openOnce"
      :class="{collapsed: !isOpen, disabled: disabled}">
    <slot name="section-header"></slot>
  </button>
  <div class="collapse" :class="{show: isOpen}" :id="id">
    <slot name="section-contents" v-if="open"></slot>
  </div>
</div>
